export const newsHeroSubtitle = 'Announcements';
export const newsHeroTitle = '공지사항';
export const newsHeroDescription = '솔티드의 주요 공지사항을 확인하세요';

// Tabs
export const tabArticles = '기사';
export const tabNotice = '공지사항';
export const tabEvents = 'Events';

// Search
export const searchTypeTitle = '제목';
export const searchTypeContent = '내용';
export const searchPlaceholder = '검색어를 입력하세요';
export const searchButton = '검색';
export const resetButton = '초기화';

// Table Headers
export const tableHeaderNumber = '번호';
export const tableHeaderTitle = '제목';
export const tableHeaderAuthor = '작성자';
export const tableHeaderDate = '등록일';
export const tableHeaderViews = '조회';

// Messages
export const noResults = '검색 결과가 없습니다.';
export const loading = '로딩 중...';

export default {
  newsHeroSubtitle,
  newsHeroTitle,
  newsHeroDescription,
  tabArticles,
  tabNotice,
  tabEvents,
  searchTypeTitle,
  searchTypeContent,
  searchPlaceholder,
  searchButton,
  resetButton,
  tableHeaderNumber,
  tableHeaderTitle,
  tableHeaderAuthor,
  tableHeaderDate,
  tableHeaderViews,
  noResults,
  loading
};